import { Pagination } from "@/domain/entities/Pagination";

export class Country {
  id = 0;
  code = "";
  name = "";
  status = "";
  currency = "";
  createdBy = 0;
  updatedBy = 0;
  createdAt = "";
  updatedAt = "";

  constructor(fields?: Partial<Country>) {
    Object.assign(this, fields);
  }
}

export class City {
  id = 0;
  name = "";
  isActive = "";
  isSundayDelivery = "";
  code = "";
  timezone = "";
  freeTradeZone = "";
  countryId = 0;
  originTransit = "";
  destinationTransit = "";
  districtDefault = "";
  createdBy = 0;
  updatedBy = 0;
  createdAt = "";
  updatedAt = "";

  constructor(fields?: Partial<City>) {
    Object.assign(this, fields);
  }
}

export class District {
  id = 0;
  code = "";
  name = "";
  type = "";
  cityId = 0;
  ursaCode = "";
  originZipCode = "";
  destinationZipCode = "";
  vendorCode = "";
  status = "";
  isCod = "";
  isPtpos = "";
  createdBy = 0;
  updatedBy = 0;
  slaOrigin = 0;
  slaDestination = 0;
  minSlaOrigin = 0;
  maxSlaOrigin = 0;
  minSlaDestination = 0;
  maxSlaDestination = 0;
  city: any = null;
  vendorOriginCode = "";
  vendorDestinationCode = "";
  vendorBranchCode = "";
  createdAt = "";
  updatedAt = "";
  areaType = "";

  constructor(fields?: Partial<District>) {
    Object.assign(this, fields);
  }
}
export class PartnerLocation {
  id = 0;
  partnerId = 0;
  districtCode = "";
  cityCode = "";
  createdAt = "";
  updatedAt = "";
  country: Country = new Country();
  city: City = new City();
  district: District = new District();
  defaultLocation = false;
  partner: any = null;

  constructor(fields?: Partial<PartnerLocation>) {
    Object.assign(this, fields);
  }
}

export class PartnerDetail {
  partnerId = 0;
  partnerType = "";
  partnerName = "";
  partnerCode = "";
  partnerElexysCode = "";
  partnerBalance = 0;
  partnerAddress = "";
  partnerLocationId = 0;
  partnerLocationCityCode = "";
  partnerDistrict = "";
  partnerDistrictCode = "";
  partnerCity: Array<any> = [];
  partnerPhoneNumber = "";
  partnerTaxNumber = "";
  partnerParentType = "";
  partnerParentId = 0;
  partnerParentName = "";
  partnerStartContract = new Date();
  partnerEndContract = new Date();
  partnerContactName = "";
  partnerContactJobTitle = "";
  partnerContactEmail = "";
  partnerContactPhoneNumber: any;
  partnerContractStatus = "";
  partnerIsBanned = false;
  partnerBannedReason = "";
  partnerCreatedAt = new Date();
  partnerUpdatedAt = new Date();
  partnerCreatedBy = "";
  partnerUpdatedBy = "";
  vaNumbers: VaNumbers[] = [];
  partnerLatitude = "";
  partnerLongitude = "";
  partnerReferralCode = "";
  partnerReferrerCode = "";
  partnerIsCodDelivery = false;
  partnerIsCodBooking = false;
  partnerIsPcu = false;
  partnerIsAllowBookVippack = false;
  partnerIdSttReturn = 0;
  partnerNameSttReturn = "";
  partnerTypeSttReturn = "";
  partnerPosType = "";
  partnerPosParentId = undefined as number | undefined;
  partnerPosParentName = "";
  partnerPosParentIdDefault = undefined as number | undefined;
  partnerPosParentNameDefault = "";
  partnerPosReverseJourney = "";
  partnerPosBranchCommission: any = 0;
  partnerPosReverseJourneyCode = "";
  partnerPosReverseJourneyName = "";
  partnerPosAttachFiles: string[] = [];
  partnerPosSaldoDeposit = 0;
  partnerPosSaldoDepositFormated = "";
  partnerPosFirstDateTopup = "";
  partnerPosFirstTransaction = "";
  partnerPosPickupManifest = "";
  partnerPosTieringLevel = "";
  partnerOwnershipId = undefined as number | undefined;
  partnerOwnershipName = "";
  partnerOwnershipIdDefault = undefined as number | undefined;
  partnerOwnershipNameDefault = "";
  partnerAreaDeliveries: Array<any> = [];
  partnerPosOwnedList: Array<any> = [];
  partnerLocation = new PartnerLocation();
  partnerIsPosOwnSales = false;
  lastTransaction = "";

  constructor(fields?: Partial<PartnerDetail>) {
    Object.assign(this, fields);
  }
}

export class ConsolidatorByCity {
  pagination: Pagination;
  consolidatorByCityData: Array<ConsolidatorByCityData>;
  constructor(
    pagination: Pagination,
    consolidatorByCityData: Array<ConsolidatorByCityData>
  ) {
    this.pagination = pagination;
    this.consolidatorByCityData = consolidatorByCityData;
  }
}

export class VaNumbers {
  bankAccountAccountNumber: string;
  bankAccountBankLogo: string;
  bankAccountBankName: string;
  bankAccountLabel: string;
  constructor(
    bankAccountAccountNumber: string,
    bankAccountBankLogo: string,
    bankAccountBankName: string,
    bankAccountLabel: string
  ) {
    this.bankAccountAccountNumber = bankAccountAccountNumber;
    this.bankAccountBankLogo = bankAccountBankLogo;
    this.bankAccountBankName = bankAccountBankName;
    this.bankAccountLabel = bankAccountLabel;
  }
}

export class ConsolidatorByCityData {
  id: number;
  name: string;
  address: string;
  balance: number;
  code: string;
  lat: number;
  long: number;
  type: string;
  createdAt: string;
  updatedAt: string;
  parentId: number;
  parentName: string;
  parentType: string;
  contractEnd: string;
  contractStatus: string;
  isBanned: boolean;
  isRegistry: boolean;

  constructor(
    id: number,
    name: string,
    address: string,
    balance: number,
    code: string,
    lat: number,
    long: number,
    type: string,
    createdAt: string,
    updatedAt: string,
    parentId: number,
    parentName: string,
    parentType: string,
    contractEnd: string,
    contractStatus: string,
    isBanned: boolean,
    isRegistry: boolean
  ) {
    this.id = id;
    this.name = name;
    this.address = address;
    this.balance = balance;
    this.code = code;
    this.lat = lat;
    this.long = long;
    this.type = type;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.parentId = parentId;
    this.parentName = parentName;
    this.parentType = parentType;
    this.contractEnd = contractEnd;
    this.contractStatus = contractStatus;
    this.isBanned = isBanned;
    this.isRegistry = isRegistry;
  }
}

export class PartnerBank {
  bankCode = "";
  bankName = "";
  bankRouting: string[] = [];
  constructor(fields?: Partial<PartnerBank>) {
    Object.assign(this, fields);
  }
}

export class ClientNamePOS {
  pagination: Pagination;
  data: Array<ClientNamePOSData>;

  constructor(pagination: Pagination, data: Array<ClientNamePOSData>) {
    this.pagination = pagination;
    this.data = data;
  }
}

export class ClientNamePOSData {
  clientId = 0;
  clientCode = "";
  clientName = "";
  clientStatus = false;
  clientIsCOD = false;
  clientIsDO = false;
  clientOriginCity = "";
  clientCategory = "";
  clientPackageType = "";
  clientCodConfigAmount = "";
  clientAlias = "";
  clientCountryCode = "";
  clientPartner?: PartnerDetail;
  clientPhone = "";
  clientAddress = "";
  clientDistrictCode = "";
  clientDistrictId?: number;
  clientDistrictName = "";
  clientDistrictOriginZipCode: string[] = [];
  clientIsDfod?: boolean;
  isShowShippingRate?: boolean;

  constructor(fields?: Partial<ClientNamePOSData>) {
    Object.assign(this, fields);
  }
}

export class AreaDeliveries {
  cityCode: string;
  cityName: string;
  districts: Array<DistrictData>;
  constructor(
    cityCode: string,
    cityName: string,
    districts: Array<DistrictData>
  ) {
    this.cityCode = cityCode;
    this.cityName = cityName;
    this.districts = districts;
  }
}


export class DistrictData {
  code: string;
  name: string;

  constructor(
    code: string,
    name: string,
  ) {
    this.code = code;
    this.name = name;
  }
}


export class PosOwnedList {
  id: number;
  name: string;
  districtCode: string;
  districtName: string;
  cityCode: string;
  cityName: string;
  constructor(
    id: number,
    name: string,
    districtCode: string,
    districtName: string,
    cityCode: string,
    cityName: string,
  ) {
    this.id = id;
    this.name = name;
    this.districtCode = districtCode;
    this.districtName = districtName;
    this.cityCode = cityCode;
    this.cityName = cityName;
  }
}
